import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { custom } from 'devextreme/ui/dialog';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ButtonActionEnum } from '../models/button-action.enum';

@Injectable({
  providedIn: 'root',
})
export class DialogHelperService {
  constructor(private translateService: TranslateService) {}

  confirmDialog(
    message: string,
    confirmText: string = this.translateService.instant('general.yes'),
    unConfirmText: string = this.translateService.instant('general.no')
  ): Observable<any> {
    const confirmDialog = custom({
      messageHtml: message,
      buttons: [
        {
          text: confirmText,
          onClick: () => ({ confirm: true }),
        },
        {
          text: unConfirmText,
          onClick: () => ({ confirm: false }),
        },
      ],
      showTitle: false,
      dragEnabled: false,
    });
    return from(confirmDialog.show()).pipe(map((click: any) => click.confirm));
  }

  notificationDialog(
    message: string,
    confirmText: string = this.translateService.instant('actions.ok')
  ): Observable<any> {
    const confirmDialog = custom({
      messageHtml: message,
      buttons: [
        {
          text: confirmText,
          onClick: () => ({ confirm: true }),
        },
      ],
      showTitle: false,
      dragEnabled: false,
    });
    return from(confirmDialog.show()).pipe(map((click: any) => click.confirm));
  }

  unsavedDocumentDialog(
    message: string = this.translateService.instant('confirmMessages.do_you_want_to_save_changes'),
    confirmText: string = this.translateService.instant('actions.save'),
    unConfirmText: string = this.translateService.instant('actions.dont_save'),
    cancelText: string = this.translateService.instant('actions.cancel')
  ): Observable<any> {
    const confirmDialog = custom({
      messageHtml: message,
      buttons: [
        {
          text: confirmText,
          onClick: () => ({ buttonActionId: ButtonActionEnum.Save }),
        },
        {
          text: unConfirmText,
          onClick: () => ({ buttonActionId: ButtonActionEnum.DontSave }),
        },
        {
          text: cancelText,
          onClick: () => ({ buttonActionId: ButtonActionEnum.Cancel }),
        },
      ],
      showTitle: false,
      dragEnabled: false,
    });
    return from(confirmDialog.show()).pipe(map((click: any) => click.buttonActionId));
  }
}
